import React, { useState } from 'react';
import { Typography, Box, Button } from '@mui/material';
import { motion } from 'framer-motion';

const AddNote = () => {
    const [isWorkInProgress] = useState(true);

    return (
        <Box sx={styles.container}>
            {isWorkInProgress ? (
                <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6, ease: 'easeOut' }}
                >
                    <Typography variant="h4" sx={styles.workInProgress}>
                        🚧 Work in Progress... 🚧
                    </Typography>
                    <Button sx={styles.button} variant="contained" size="large">
                    😇
                    </Button>
                </motion.div>
            ) : (
                <div>
                    {/* Future content */}
                </div>
            )}
        </Box>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
        backgroundColor: '#E3F2FD',
        padding: 2,
    },
    workInProgress: {
        color: '#008080', // Teal
        fontSize: '1.8rem',
        fontWeight: 'bold',
        mt: 3,
        textShadow: '2px 2px 8px rgba(0, 0, 0, 0.2)',
    },
    button: {
        mt: 3,
        background: 'linear-gradient(45deg, #008080, #FFD700)',
        color: '#fff',
        fontSize: '1rem',
        fontWeight: 'bold',
        borderRadius: '8px',
        padding: '10px 20px',
        textTransform: 'none',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
        transition: '0.3s',
        '&:hover': {
            background: 'linear-gradient(45deg, #006666, #FFC107)',
            transform: 'scale(1.05)',
        },
    },
};

export default AddNote;
